import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { User } from 'src/app/core/models/auth.models';
import { EventService } from 'src/app/core/services/event.service';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { ProposalModel } from 'src/app/pages/properties/create-edit/proposals/models/proposals.model';
import { PropertyProposalsModel } from 'src/app/pages/proposals/models/property-proposals.model';
import { ProposalsService } from 'src/app/pages/proposals/services/proposals.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { proposalHistoryObsLabelKey } from "src/app/pages/proposals/utils/proposal-history-obs-label.util";

@Component({
  selector: 'app-proposal-view',
  templateUrl: './proposal-view.component.html',
  styleUrls: ['./proposal-view.component.scss']
})
export class ProposalViewComponent implements OnInit, OnChanges {

  pathImage = `${environment.apiUrl}${environment.dirPropertiesImages}/`;
  pathProfileImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;
  @Input() proposal: PropertyProposalsModel | null = null;
  @Input() loginUser!: User;
  /**
   * Só consulta: esconde apagar/editar/recusar/contrapropor/aceitar e o
   * workflow. Usado quando a proposta é mostrada fora do negócio que a gere
   * (ex.: aba "Origem" do processo).
   */
  @Input() readOnly = false;
  /**
   * Negócio que está a mostrar a proposta (aba Propostas do deal). Com ele, o
   * modal de venda do "Validar" não pede para escolher o negócio.
   */
  @Input() lockedDealId: any = null;
  dirProposalsFiles = `${environment.apiUrl}/proposals/file/`; 
  checkProposalForm!: FormGroup;
  counterProposalForm!: FormGroup;
  propertyDetailsForm!: FormGroup;
  workflowStepForm!: FormGroup;
  uploadWorkflowDocumentForm!: FormGroup;
  paymentsConditions: any[] = [];
  modalCheck!: NgbModalRef;
  openNewAgent: { listing: boolean; selling: boolean } = { listing: false, selling: false };
  selected: { listing: any; selling: any } = { listing: null, selling: null };
  agentsExceptListing: any[] = [];
  agentsExceptSelling: any[] = [];
  propertyAgentsData: any[] = [];
  allAgents: any[] = [];
  stores: any[] = [];
  listingSelected: any[] = [];
  sellingSelected: any[] = [];
  submitedCounter: boolean = false;
  agentsSelectedType: any;
  submitedCheck: boolean = false;
  submitedWorkflow: boolean = false;
  submitedUploadDocument: boolean = false;
  workflowMode: 'accept-and-step' | 'step' = 'step';
  subscription: Subscription = new Subscription();
  properties!: PropertyProposalsModel[];
  additionalProposalDetails: Array<{ label: string; value: any }> = [];
  proposalProposersList: any[] = [];

  constructor(
    private translateService: TranslateService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private proposalsService: ProposalsService,
    private eventService: EventService,
    public permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.refreshProposalExtraInfo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['proposal']) {
      this.refreshProposalExtraInfo();
    }
  }

  formatSizeUnits(bytes: any) {
    if (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
    else if (bytes >= 1048576) { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
    else if (bytes >= 1024) { bytes = (bytes / 1024).toFixed(2) + " KB"; }
    else if (bytes > 1) { bytes = bytes + " bytes"; }
    else if (bytes == 1) { bytes = bytes + " byte"; }
    else { bytes = "0 bytes"; }
    return bytes;
  }

  /**
   * Counter Proposal
   */


  counterProposal(content: any, proposal: ProposalModel) {
    this.initCounterForm(proposal);
    this.modalService.open(content, { size: 'md', centered: true, backdropClass: 'z-modal', windowClass: 'z-modal' });
  }

  initCounterForm(proposal: ProposalModel) {
    this.counterProposalForm = this.formBuilder.group({
      proposalId: [proposal.id],
      clientName: [proposal.clientName],
      value: [null, [Validators.required, Validators.min(1)]],
      obs: [null],
      file: [null]
    })
    if (proposal.agencyProposal) {
      const lastVal = proposal.lastAction ? proposal.lastAction.saleDivision : proposal.firstProposal ? proposal.firstProposal.saleDivision : 50;
      this.counterProposalForm.setControl('saleDivision', new FormControl(lastVal, [Validators.required]))
    }
  }

  get formCounter() {
    return this.counterProposalForm.controls;
  }

  submitCounterProposal() {
    this.submitedCounter = true;
    if (this.counterProposalForm.valid) {
      let formData = new FormData();
      const proposalId = this.counterProposalForm.get('proposalId')?.value;
      // formData.append('data', JSON.stringify(fData));
      formData.append('value', this.counterProposalForm.get('value')?.value);

      if (this.counterProposalForm.get('obs')?.value)
        formData.append('obs', this.counterProposalForm.get('obs')?.value);

      if (this.counterProposalForm.get('file')?.value)
        formData.append('file', this.counterProposalForm.get('file')?.value);

      if (this.counterProposalForm.get('saleDivision')?.value)
        formData.append('saleDivision', this.counterProposalForm.get('saleDivision')?.value)

      this.proposalsService.counterProposal(proposalId, formData).subscribe({
        next: (data: ProposalModel) => {
          this.submitedCounter = false;
          document.getElementById('proposal-dismiss-btn')?.click();
          if (this.proposal && data.history) {
            this.proposal?.proposal?.history?.unshift(data?.history[0]);
            this.proposal.proposal.lastAction = data?.history[0];
          }
          // Sem isto a contraproposta só actualizava o objeto local deste
          // componente: quem estava a ver a lista de propostas ficava com o
          // histórico desactualizado até recarregar a página. Aceitar e
          // recusar já avisavam — só este caminho é que não.
          this.getData();
        },
        error: (err) => {
          this.errorMsg(this.translateService.instant('t-error-creating'));
        }
      });

    }
  }

  onFileChangeCounter(event: any) {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.counterProposalForm.patchValue({
        file: file
      });
    }
    event.target.value = '';
  }

  deleteFileCounter() {
    this.counterProposalForm.patchValue({
      file: null
    });
  }

  clearFormCounter() {
    this.counterProposalForm.reset();
  }

  /**
   * Refuse Proposal
   */

  /** "Obs", "Motivo da recusa" ou "Motivo do cancelamento", conforme a entrada. */
  obsLabelKey(entry: any, history: any[] | null | undefined): string {
    return proposalHistoryObsLabelKey(entry, history);
  }

  /**
   * O motivo (opcional) fica no histórico da proposta. `afterAcceptance`: o
   * botão diz "Cancelar" (proposta já aceite) e os textos são os de cancelar.
   */
  refuseProposal(proposalId: any, value: any, afterAcceptance = false) {
    Swal.fire({
      title: this.translateService.instant(afterAcceptance ? 't-proposals.t-cancel-title' : 't-proposals.t-refuse-title'),
      text: this.translateService.instant('t-proposals.t-refuse-text'),
      icon: 'warning',
      input: 'textarea',
      inputLabel: this.translateService.instant(afterAcceptance ? 't-proposals.t-cancel-reason' : 't-proposals.t-refuse-reason'),
      inputPlaceholder: this.translateService.instant(afterAcceptance ? 't-proposals.t-cancel-reason' : 't-proposals.t-refuse-reason'),
      showCancelButton: true,
      confirmButtonColor: '#008a00',
      cancelButtonColor: '#f46a6a',
      confirmButtonText: this.translateService.instant(afterAcceptance ? 't-proposals.t-cancel-confirm' : 't-proposals.t-refuse-confirm'),
      cancelButtonText: this.translateService.instant('t-proposals.t-refuse-cancel')
    }).then(result => {
      // Com input, `value` é o texto: vazio sem motivo, mas confirmado.
      if (result.isConfirmed) {
        const reason = `${result.value ?? ''}`.trim();
        this.proposalsService.declineProposal(proposalId, value, reason).subscribe({
          next: (data: { proposal: ProposalModel, status: boolean | number }) => {
            if (data?.proposal.history) {
              if (this.proposal) {
                this.proposal?.proposal?.history?.unshift(data?.proposal?.history[0]);
                this.proposal.proposal.lastAction = data?.proposal?.history[0];
              }
            }
            this.getData();
          },
          error: (err) => {
            this.errorMsg(this.translateService.instant('t-error-creating'));
          }
        })
      }
    });
  }

  /**
   * Delete Proposal
   */


  deleteProposal(id: any) {
    Swal.fire({
      title: this.translateService.instant('t-proposals.t-delete-title'),
      text: this.translateService.instant('t-proposals.t-delete-text'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#008a00',
      cancelButtonColor: '#f46a6a',
      confirmButtonText: this.translateService.instant('t-proposals.t-delete-confirm'),
      cancelButtonText: this.translateService.instant('t-proposals.t-delete-cancel')
    }).then(result => {
      if (result.value) {
        this.proposalsService.deleteProposal(id).subscribe({
          next: (data: { status?: boolean | number }) => {
            document.getElementById('closecanvas')?.click();
            this.proposal = null;
            this.getData();
          },
          error: (err) => {
            this.errorMsg(this.translateService.instant('t-delete-error'));
          }
        })
      }
    });
  }

  /**
   * Accept proposal
   */
  acceptProposal(proposalId: any, value: any) {
    Swal.fire({
      title: this.translateService.instant('t-proposals.t-accept-title'),
      text: this.translateService.instant('t-proposals.t-accept-text'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#008a00',
      cancelButtonColor: '#f46a6a',
      confirmButtonText: this.translateService.instant('t-proposals.t-accept-confirm'),
      cancelButtonText: this.translateService.instant('t-proposals.t-accept-cancel')
    }).then(result => {
      if (result.value) {
        this.proposalsService.acceptProposal(proposalId, value).subscribe({
          next: (data: { proposal: ProposalModel, reservedId: any }) => {
            if (data?.proposal?.history) {
              if (this.proposal) {
                this.proposal?.proposal?.history?.unshift(data.proposal?.history[0]);
                this.proposal.proposal.lastAction = data.proposal?.history[0];
              }
              this.getData();
            }
          },
          error: (err) => {
            this.errorMsg(
              this.getTranslatedErrorMessage(err) ??
                this.translateService.instant('t-error-creating'),
            );
          }
        })
      }
    });
  }

  // O exception filter global aninha as respostas de HttpException:
  // { message: { statusCode, message: '<chave i18n>', error } }. Quando a
  // mensagem é uma chave t-... com tradução, mostra-a em vez do erro genérico.
  private getTranslatedErrorMessage(error: any): string | null {
    const messagePayload = error?.error?.message;
    const messageKey =
      typeof messagePayload === 'string' ? messagePayload : messagePayload?.message;
    if (typeof messageKey !== 'string' || !messageKey.startsWith('t-')) {
      return null;
    }
    const translated = this.translateService.instant(messageKey);
    return translated && translated !== messageKey ? translated : null;
  }

  private getHistoryTimestamp(history: any): number {
    const timestamp = history?.date ? new Date(history.date).getTime() : NaN;
    return Number.isFinite(timestamp) ? timestamp : 0;
  }

  private getNormalizedHistoryStatusCode(history: any): string {
    return this.normalizeWorkflowStatusCode(
      history?.proposalStatusCode ?? history?.originalStatus ?? history?.proposalStatus,
    );
  }

  getLatestHistory(proposal: PropertyProposalsModel | null = this.proposal) {
    const history = proposal?.proposal?.history ?? [];
    if (!Array.isArray(history) || history.length === 0) {
      return null;
    }

    return history.reduce((latest: any, current: any) => {
      const latestTime = this.getHistoryTimestamp(latest);
      const currentTime = this.getHistoryTimestamp(current);

      if (currentTime === latestTime) {
        return Number(current?.id ?? 0) > Number(latest?.id ?? 0) ? current : latest;
      }

      return currentTime > latestTime ? current : latest;
    }, history[0]);
  }

  isLatestHistoryEntry(
    history: any,
    proposal: PropertyProposalsModel | null = this.proposal,
  ): boolean {
    const latest = this.getLatestHistory(proposal);
    if (!latest || !history) {
      return false;
    }

    const latestId = this.normalizeIdentifier(latest?.id).toLowerCase();
    const historyId = this.normalizeIdentifier(history?.id).toLowerCase();
    if (latestId && historyId) {
      return latestId === historyId;
    }

    return this.getHistoryTimestamp(latest) === this.getHistoryTimestamp(history);
  }

  isRentProposal(proposal: PropertyProposalsModel | null = this.proposal) {
    return !!proposal?.property?.isRent;
  }

  private hasReservationPaymentCondition() {
    const payments =
      this.proposal?.property?.paymentsConditions ??
      this.paymentsConditions ??
      [];

    return (payments ?? []).some((payment: any) => {
      const type = `${payment?.type ?? ''}`.toUpperCase();
      const moment = `${payment?.paymentMoment ?? ''}`.toUpperCase();
      return type === 'RESERVATION' || moment.includes('RESERV');
    });
  }

  private getDefaultNextWorkflowStatus(
    proposal: PropertyProposalsModel | null = this.proposal,
  ): 'Reserved' | 'Sale Agreement' {
    const latest = this.getLatestHistory(proposal);
    const statusCode = this.getNormalizedHistoryStatusCode(latest);

    if (statusCode === 'reserved') {
      return 'Sale Agreement';
    }

    if (statusCode === 'accepted') {
      return this.hasReservationPaymentCondition()
        ? 'Reserved'
        : 'Sale Agreement';
    }

    return 'Reserved';
  }

  private normalizeWorkflowStatusCode(statusCode: any): string {
    const normalized = String(statusCode ?? '')
      .trim()
      .toLowerCase()
      .replace(/[\s_-]+/g, '');

    if (normalized === 'cpcv') {
      return 'saleagreement';
    }

    return normalized;
  }

  private isSameUser(userIdA: any, userIdB: any): boolean {
    const normalizedA = this.normalizeIdentifier(userIdA).toLowerCase();
    const normalizedB = this.normalizeIdentifier(userIdB).toLowerCase();
    return !!normalizedA && normalizedA === normalizedB;
  }

  private getProposalSenderIdCandidates(
    proposal: PropertyProposalsModel | null = this.proposal,
  ): string[] {
    const firstProposalHistory =
      proposal?.proposal?.firstProposal ??
      proposal?.proposal?.history?.find(
        (history: any) =>
          this.normalizeWorkflowStatusCode(history?.proposalStatusCode) ===
          'firstproposal',
      );

    return [
      proposal?.proposal?.userId,
      proposal?.proposal?.user?.id,
      proposal?.proposal?.createdBy,
      firstProposalHistory?.user?.id,
      firstProposalHistory?.user,
      firstProposalHistory?.createdBy,
    ]
      .map((value) => this.normalizeIdentifier(value).toLowerCase())
      .filter(Boolean);
  }

  private isProposalSender(
    proposal: PropertyProposalsModel | null = this.proposal,
  ): boolean {
    const currentUserId = this.normalizeIdentifier(this.loginUser?.id).toLowerCase();
    if (!currentUserId) {
      return false;
    }

    return this.getProposalSenderIdCandidates(proposal).includes(currentUserId);
  }

  private getProposalStoreId(
    proposal: PropertyProposalsModel | null = this.proposal,
  ): any {
    const propertyAny = proposal?.property as any;
    return propertyAny?.store?.id ?? propertyAny?.storeId ?? null;
  }

  private canOverrideSenderRestriction(
    proposal: PropertyProposalsModel | null = this.proposal,
  ): boolean {
    return this.permissionsService.checkMasterSomePermissions(
      ['ACCEPT_PROPOSALS', 'REJECT_PROPOSALS', 'VALIDATE_PROPOSALS', 'MAKE_COUNTEROFFER'],
      this.getProposalStoreId(proposal),
    );
  }

  canDecideProposal(proposal: PropertyProposalsModel | null = this.proposal): boolean {
    if (this.canOverrideSenderRestriction(proposal)) {
      return true;
    }
    return !this.isProposalSender(proposal);
  }

  canOpenWorkflowFromAccept(proposal: PropertyProposalsModel | null = this.proposal) {
    const latest = this.getLatestHistory(proposal);
    if (!latest) return false;
    const statusCode = this.getNormalizedHistoryStatusCode(latest);

    return ![
      'accepted',
      'reserved',
      'saleagreement',
      'declined',
      'salecompleted',
    ].includes(statusCode);
  }

  canAdvanceWorkflowStep(proposal: PropertyProposalsModel | null = this.proposal) {
    const latest = this.getLatestHistory(proposal);
    if (!latest) return false;
    if (this.isProposalSender(proposal) && !this.canOverrideSenderRestriction(proposal)) return false;
    if (proposal?.property?.saleInProgress) return false;
    const statusCode = this.getNormalizedHistoryStatusCode(latest);

    if (statusCode === 'accepted') return true;
    if (statusCode === 'reserved') return !this.isDocumentPending(latest);

    return false;
  }

  canCheckWorkflowProposal(proposal: PropertyProposalsModel | null = this.proposal) {
    const latest = this.getLatestHistory(proposal);
    if (!latest) return false;
    if (this.isProposalSender(proposal) && !this.canOverrideSenderRestriction(proposal)) return false;
    const statusCode = this.getNormalizedHistoryStatusCode(latest);

    return (
      statusCode === 'saleagreement' &&
      !this.isDocumentPending(latest) &&
      !proposal?.property?.saleInProgress
    );
  }

  /** "Aguardar documento": cancelar continua possível (o servidor já aceita). */
  canCancelPendingDocument(proposal: PropertyProposalsModel | null = this.proposal) {
    const latest = this.getLatestHistory(proposal);
    if (!latest || !this.isDocumentPending(latest)) return false;
    if (this.isProposalSender(proposal) && !this.canOverrideSenderRestriction(proposal)) return false;
    if (proposal?.property?.saleInProgress) return false;
    const statusCode = this.getNormalizedHistoryStatusCode(latest);
    return ['accepted', 'reserved', 'saleagreement'].includes(statusCode);
  }

  canUploadPendingDocument(proposal: PropertyProposalsModel | null = this.proposal) {
    const latest = this.getLatestHistory(proposal);
    const hasPendingDocument = this.isDocumentPending(latest);
    const isProposalSender = this.isProposalSender(proposal);
    const canValidate =
      !!proposal &&
      (this.permissionsService.checkMasterPermission(
        'VALIDATE_PROPOSALS',
        proposal?.property?.store?.id,
      ) ||
        this.permissionsService.checkAgentPermission(
          proposal?.property?.mainAgent?.id,
          'VALIDATE_PROPOSALS',
        ));
    const isCommercialDirectorWithValidationPermission =
      this.permissionsService.currentRole === 'COMMERCIAL DIRECTOR' &&
      this.permissionsService.hasPermission('VALIDATE_PROPOSALS');

    return (
      (hasPendingDocument || (!!latest?.requiresDocument && this.hasStepFiles(latest))) &&
      (isProposalSender ||
        canValidate ||
        isCommercialDirectorWithValidationPermission)
    );
  }

  canCounterProposal(proposal: PropertyProposalsModel | null = this.proposal): boolean {
    if (!proposal) {
      return false;
    }

    const senderIds = this.getProposalSenderIdCandidates(proposal);
    const canCounterAsSender = senderIds.some((senderId) =>
      this.permissionsService.checkAgentPermission(senderId, 'MAKE_COUNTEROFFER'),
    );

    return (
      this.permissionsService.checkMasterPermission(
        'MAKE_COUNTEROFFER',
        proposal.property?.store?.id,
      ) ||
      this.permissionsService.checkAgentPermission(
        proposal.property?.mainAgent?.id,
        'MAKE_COUNTEROFFER',
      ) ||
      canCounterAsSender ||
      (this.isProposalSender(proposal) &&
        this.permissionsService.hasPermission('MAKE_COUNTEROFFER'))
    );
  }

  isDocumentPending(history: any): boolean {
    if (history?.documentPending !== undefined && history?.documentPending !== null) {
      return !!history?.documentPending;
    }

    return (
      !!history?.requiresDocument &&
      !history?.documentDeliveredAt &&
      (!history?.file || history?.file?.length === 0) &&
      !history?.expiredAt
    );
  }

  isDocumentRequested(history: any) {
    return !!history?.requiresDocument;
  }

  onWorkflowDocumentToggle() {
    if (!this.workflowStepForm.get('requestDocument')?.value) {
      this.workflowStepForm.patchValue({
        useDeadline: false,
        documentDeadline: null,
      });
    }
  }

  onFileChangeWorkflow(event: any) {
    this.appendFiles(this.workflowStepForm, event);
  }

  deleteWorkflowFile(index: number) {
    this.removeFileAt(this.workflowStepForm, index);
  }

  onFileChangeUploadWorkflow(event: any) {
    this.appendFiles(this.uploadWorkflowDocumentForm, event);
  }

  deleteUploadWorkflowFile(index: number) {
    this.removeFileAt(this.uploadWorkflowDocumentForm, index);
  }

  /**
   * Vários ficheiros por passo (CPCV com mais de um anexo): a seleção
   * acumula, sem repetir o mesmo ficheiro (nome + tamanho).
   */
  private appendFiles(form: any, event: any): void {
    const picked: File[] = Array.from((event?.target?.files ?? []) as FileList);
    if (picked.length) {
      const current: File[] = Array.isArray(form?.get('files')?.value)
        ? [...form.get('files').value]
        : [];
      for (const file of picked) {
        if (!current.some((f) => f.name === file.name && f.size === file.size)) {
          current.push(file);
        }
      }
      form?.patchValue({ files: current });
    }
    if (event?.target) {
      event.target.value = '';
    }
  }

  private removeFileAt(form: any, index: number): void {
    const current: File[] = Array.isArray(form?.get('files')?.value)
      ? [...form.get('files').value]
      : [];
    current.splice(index, 1);
    form?.patchValue({ files: current });
  }

  /** O passo já tem documentos: o botão passa a "juntar documentos". */
  hasStepFiles(history: any): boolean {
    return Array.isArray(history?.file) && history.file.length > 0;
  }

  openWorkflowStep(content: any, mode: 'accept-and-step' | 'step' = 'step') {
    const proposalId = this.proposal?.proposal?.id;
    if (!proposalId) {
      return;
    }

    this.workflowMode = mode;
    const latest = this.getLatestHistory(this.proposal);
    const latestStatusCode = this.getNormalizedHistoryStatusCode(latest);
    const nextStatus = this.getDefaultNextWorkflowStatus(this.proposal);

    this.workflowStepForm = this.formBuilder.group({
      proposalId: [proposalId, Validators.required],
      status: [
        {
          value: nextStatus,
          disabled: latestStatusCode === 'reserved',
        },
        Validators.required,
      ],
      obs: [null],
      requestDocument: [false],
      useDeadline: [false],
      documentDeadline: [null],
      files: [[] as File[]],
    });

    this.submitedWorkflow = false;
    this.modalService.open(content, {
      size: 'lg',
      centered: true,
      backdropClass: 'custom-modal',
    });
  }

  submitWorkflowStep() {
    this.submitedWorkflow = true;
    if (!this.workflowStepForm.valid) {
      return;
    }

    const proposalId = this.workflowStepForm.get('proposalId')?.value;

    const executeStep = () => {
      const formData = new FormData();
      const rawStatus = this.workflowStepForm.getRawValue()?.status;
      if (rawStatus) {
        formData.append('status', rawStatus);
      }
      if (
        this.workflowMode === 'step' &&
        this.workflowStepForm.get('obs')?.value
      ) {
        formData.append('obs', this.workflowStepForm.get('obs')?.value);
      }
      formData.append(
        'requestDocument',
        `${!!this.workflowStepForm.get('requestDocument')?.value}`,
      );
      formData.append(
        'useDeadline',
        `${!!this.workflowStepForm.get('useDeadline')?.value}`,
      );
      if (this.workflowStepForm.get('documentDeadline')?.value) {
        formData.append(
          'documentDeadline',
          this.workflowStepForm.get('documentDeadline')?.value,
        );
      }
      for (const file of this.workflowStepForm.get('files')?.value ?? []) {
        formData.append('file', file);
      }

      this.proposalsService.advanceProposalWorkflowStep(proposalId, formData).subscribe({
        next: (proposal: ProposalModel) => {
          this.submitedWorkflow = false;
          document.getElementById('proposal-dismiss-btn')?.click();
          this.syncProposalState(proposalId, proposal);
          this.getData();
        },
        error: () => {
          this.errorMsg(this.translateService.instant('t-error-updating'));
        },
      });
    };

    if (this.workflowMode === 'accept-and-step') {
      this.proposalsService.acceptProposalWorkflow(proposalId, {
        obs: this.workflowStepForm.get('obs')?.value ?? null,
      }).subscribe({
        next: (proposal: ProposalModel) => {
          this.syncProposalState(proposalId, proposal);
          executeStep();
        },
        error: () => {
          this.errorMsg(this.translateService.instant('t-error-creating'));
        },
      });
      return;
    }

    executeStep();
  }

  openUploadWorkflowDocument(content: any, history: any) {
    this.uploadWorkflowDocumentForm = this.formBuilder.group({
      historyId: [history?.id, Validators.required],
      files: [[] as File[], (control: any) => (Array.isArray(control?.value) && control.value.length ? null : { required: true })],
      obs: [null],
    });
    this.submitedUploadDocument = false;
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdropClass: 'custom-modal',
    });
  }

  submitUploadWorkflowDocument() {
    this.submitedUploadDocument = true;
    if (!this.uploadWorkflowDocumentForm.valid) {
      return;
    }

    const formData = new FormData();
    for (const file of this.uploadWorkflowDocumentForm.get('files')?.value ?? []) {
      formData.append('file', file);
    }
    if (this.uploadWorkflowDocumentForm.get('obs')?.value) {
      formData.append('obs', this.uploadWorkflowDocumentForm.get('obs')?.value);
    }

    const historyId = this.uploadWorkflowDocumentForm.get('historyId')?.value;
    this.proposalsService.uploadProposalWorkflowDocument(historyId, formData).subscribe({
      next: (proposal: ProposalModel) => {
        this.submitedUploadDocument = false;
        document.getElementById('proposal-dismiss-btn')?.click();
        this.syncProposalState(proposal.id, proposal);
        this.getData();
      },
      error: () => {
        this.errorMsg(this.translateService.instant('t-error-updating'));
      },
    });
  }

  private syncProposalState(proposalId: any, proposal: ProposalModel) {
    const targetId = Number(proposalId);
    if (!this.proposal?.proposal || Number(this.proposal.proposal.id) !== targetId) {
      return;
    }

    Object.assign(this.proposal.proposal, proposal);
    this.proposal.proposal.history = proposal.history ?? this.proposal.proposal.history;
    this.proposal.proposal.firstProposal = proposal.firstProposal ?? this.proposal.proposal.firstProposal;
    this.proposal.proposal.lastAction = proposal.lastAction ?? this.proposal.proposal.lastAction;
  }

  /**
   * Check Proposal
   */
  /** Negócio da proposta: o do host, senão o do lead que a originou. */
  get linkedDealId(): any {
    return (
      this.lockedDealId ??
      (this.proposal?.proposal as any)?.lead?.deal?.id ??
      null
    );
  }

  openCheck(content: any) {
    if (!this.proposal) {
      return;
    }

    const property = this.proposal.property ?? {};
    const proposalData = this.proposal.proposal ?? {};
    const latestHistory = proposalData.history?.[0];

    this.allAgents = (property.agents ?? []).map((agent: any) => ({
      ...agent,
      isListingAgent: !!agent.isListingAgent,
      isSellingAgent: !!agent.isSellingAgent,
      listingCommission: agent.listingCommission ?? agent.listingCom ?? 0,
      saleCommission: agent.saleCommission ?? agent.saleCom ?? 0,
      listingCom: agent.listingCom ?? agent.listingCommission ?? 0,
      saleCom: agent.saleCom ?? agent.saleCommission ?? 0,
    }));
    this.propertyAgentsData = this.allAgents.map((agent: any) => ({ ...agent }));

    const sourcePayments = property.paymentsConditions ?? [];
    this.paymentsConditions = (sourcePayments ?? []).map((payment: any, index: number) => ({
      ...payment,
      order: payment?.order ?? index + 1,
    }));

    if (!this.paymentsConditions.length && !property.isRent) {
      this.paymentsConditions = [
        {
          type: 'SALE_AGREEMENT',
          valueType: 'PERCENTAGE',
          value: '50',
          paymentMoment: 'CPCV',
          agencyValue: '50',
          order: 1,
        },
        {
          type: 'DEED',
          valueType: 'PERCENTAGE',
          value: '50',
          paymentMoment: 'ESCRITURA',
          agencyValue: '50',
          order: 2,
        },
      ];
    }

    this.stores = property?.store ? [property.store] : [];

    this.propertyDetailsForm = this.formBuilder.group({
      reference: [property.reference ?? null],
      store: [property?.store?.id ?? property?.store ?? null],
      businessStatus: [property.businessStatus ?? null],
      price: [property.price ?? null],
      saleDate: [latestHistory?.date ?? proposalData.proposalDate ?? new Date()],
      saleValue: [latestHistory?.value ?? property.price ?? null, [Validators.required, Validators.min(1)]],
      saleCommission: [property.saleCommission ?? null, [Validators.required, Validators.min(1)]],
      isPercentageCommission: [property.isPercentageCommission === undefined ? true : property.isPercentageCommission === true],
      sharedSale: [
        proposalData.agencyProposal ||
          proposalData.internalShare ||
          property.sharedSale ||
          false,
      ],
      shareType: [proposalData.internalShare ? 'internal' : 'external'],
      partnerStoreId: [proposalData.partnerStoreId ?? null],
      internalShareSellerId: [
        proposalData.internalShare
          ? proposalData.user?.id ?? proposalData.userId ?? null
          : null,
      ],
      internalShareSellerCommission: [
        proposalData.internalShare
          ? proposalData.user?.userEntity?.saleCommission ?? null
          : null,
      ],
      sharedCommission: [
        (proposalData?.lastAction?.saleDivision ??
          proposalData?.history?.[0]?.saleDivision) != null
          ? 100 -
            Number(
              proposalData?.lastAction?.saleDivision ??
                proposalData?.history?.[0]?.saleDivision,
            )
          : property.sharedCommission ?? 50,
      ],
      partnerEntityName: [proposalData.partnerEntityName ?? property.partnerEntityName ?? null],
      methodPaymentCommission: [property.methodPaymentCommission ?? 0],
      splitCommissionValue: [property.splitCommissionValue ?? property.saleCommission ?? null],
      paymentsConditions: [this.paymentsConditions],
      inventoryValue: [property.inventoryValue ?? null],
      dealId: [this.linkedDealId],
    });

    this.applyProposalSenderAsSellingAgent(proposalData);
    this.refreshListings();
    this.modalCheck = this.modalService.open(content, {
      size: 'xl',
      centered: true,
      backdropClass: 'custom-modal',
      scrollable: true,
    });
  }

  onProposalChecked(event: any) {
    const { proposal, listingAgents, sellingAgents } = event ?? {};

    if (proposal?.history && this.proposal?.proposal) {
      this.proposal.proposal.history?.unshift(proposal.history[0]);
      this.proposal.proposal.lastAction = proposal.history[0];
    }

    this.propertyAgentsData = this.propertyAgentsData.map((agent: any) => ({
      ...agent,
      isListingAgent: false,
      isSellingAgent: false,
    }));

    (listingAgents ?? []).forEach((listing: any) => {
      const found = this.propertyAgentsData.find((agent: any) => agent.id === listing.id);
      if (found) {
        found.isListingAgent = true;
      }
    });

    (sellingAgents ?? []).forEach((selling: any) => {
      const found = this.propertyAgentsData.find((agent: any) => agent.id === selling.id);
      if (found) {
        found.isSellingAgent = true;
      }
    });

    if (this.proposal?.property) {
      this.proposal.property.agents = this.propertyAgentsData;
    }

    this.modalCheck?.dismiss();
    this.getData();
  }

  generateProposalRef(id: any) {
    if (id) {
      const ref = id.toString().padStart(4, '0');
      return `#P${ref}`;
    } else {
      return ``;
    }
  }

  addAgent(type: 'listing' | 'selling') {
    this.selected[type] = null;
    this.openNewAgent[type] = true;
  }

  removeAgent(type: 'listing' | 'selling', id: any) {
    const agent = this.propertyAgentsData.find((item: any) => item.id === id);
    if (!agent) {
      return;
    }

    if (type === 'listing') {
      agent.isListingAgent = false;
    } else {
      agent.isSellingAgent = false;
    }
    this.refreshListings();
  }

  onChangeAgent(id: any, type: 'listing' | 'selling') {
    if (!id) {
      return;
    }

    const agent = this.allAgents.find((item: any) => item.id === id);
    if (!agent) {
      return;
    }

    if (!this.propertyAgentsData.find((item: any) => item.id === id)) {
      this.propertyAgentsData.push({ ...agent });
    }

    const selectedAgent = this.propertyAgentsData.find((item: any) => item.id === id);
    if (!selectedAgent) {
      return;
    }

    if (type === 'listing') {
      selectedAgent.isListingAgent = true;
      const newCommission = this.getNewCommission('listing');
      if (newCommission && Number(newCommission) > 0) {
        selectedAgent.listingCommission = Number(newCommission);
      }
    } else {
      selectedAgent.isSellingAgent = true;
      const newCommission = this.getNewCommission('selling');
      if (newCommission && Number(newCommission) > 0) {
        selectedAgent.saleCommission = Number(newCommission);
      }
    }

    this.openNewAgent[type] = false;
    this.refreshListings();
  }

  private getNewCommission(type: 'listing' | 'selling') {
    if (type === 'listing') {
      const agentsListing = this.propertyAgentsData.filter((item: any) => item.isListingAgent);
      const commission = agentsListing.reduce((acc: number, item: any) => acc + (Number(item.listingCommission) || 0), 0);
      return Number.isInteger(commission / (agentsListing.length + 1))
        ? commission / (agentsListing.length + 1)
        : (commission / (agentsListing.length + 1)).toFixed(2);
    }

    const agentsSelling = this.propertyAgentsData.filter((item: any) => item.isSellingAgent);
    const commission = agentsSelling.reduce((acc: number, item: any) => acc + (Number(item.saleCommission) || 0), 0);
    return Number.isInteger(commission / (agentsSelling.length + 1))
      ? commission / (agentsSelling.length + 1)
      : (commission / (agentsSelling.length + 1)).toFixed(2);
  }

  refreshListings() {
    this.agentsExceptListing = this.allAgents.filter(
      (agent: any) =>
        !this.propertyAgentsData
          .filter((item: any) => item.isListingAgent)
          .find((item: any) => item.id === agent.id),
    );

    this.agentsExceptSelling = this.allAgents.filter(
      (agent: any) =>
        !this.propertyAgentsData
          .filter((item: any) => item.isSellingAgent)
          .find((item: any) => item.id === agent.id),
    );
  }

  getSuffix() {
    return '€';
  }

  getAgents(type: 'listing' | 'selling') {
    if (type === 'listing') {
      return this.propertyAgentsData.filter((agent: any) => agent.isListingAgent);
    }
    return this.propertyAgentsData.filter((agent: any) => agent.isSellingAgent);
  }

  getStoreById(id: any) {
    const fromStores = this.stores.find((store: any) => store?.id === id)?.name;
    if (fromStores) {
      return fromStores;
    }

    const fromAgent = this.allAgents.find((agent: any) => agent?.store === id || agent?.store?.id === id);
    return fromAgent?.store?.name ?? fromAgent?.storeName ?? '';
  }

  private normalizeIdentifier(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    return `${value}`.trim();
  }

  private isSameAgent(agentA: any, agentB: any): boolean {
    const candidatesA = [
      agentA?.id,
      agentA?.agentId,
      agentA?.userId,
      agentA?.user?.id,
    ].map((value) => this.normalizeIdentifier(value)).filter(Boolean);

    const candidatesB = [
      agentB?.id,
      agentB?.agentId,
      agentB?.userId,
      agentB?.user?.id,
    ].map((value) => this.normalizeIdentifier(value)).filter(Boolean);

    if (!candidatesA.length || !candidatesB.length) {
      return false;
    }

    return candidatesA.some((value) => candidatesB.includes(value));
  }

  private matchesProposalSender(agent: any, proposal: any): boolean {
    const proposalEmail = this.normalizeIdentifier(
      proposal?.user?.email ?? proposal?.userEmail ?? proposal?.consultantEmail,
    ).toLowerCase();

    const agentEmails = [
      agent?.email,
      agent?.user?.email,
    ]
      .map((value) => this.normalizeIdentifier(value).toLowerCase())
      .filter(Boolean);

    if (proposalEmail && agentEmails.includes(proposalEmail)) {
      return true;
    }

    const proposalCandidates = [
      proposal?.userId,
      proposal?.user?.id,
      proposal?.proposalUserId,
      proposal?.consultantId,
    ].map((value) => this.normalizeIdentifier(value)).filter(Boolean);

    const agentCandidates = [
      agent?.id,
      agent?.agentId,
      agent?.userId,
      agent?.user?.id,
    ].map((value) => this.normalizeIdentifier(value)).filter(Boolean);

    if (!proposalCandidates.length || !agentCandidates.length) {
      return false;
    }

    return agentCandidates.some((value) => proposalCandidates.includes(value));
  }

  private applyProposalSenderAsSellingAgent(proposalData: any): void {
    const allCandidates = [
      ...(this.propertyAgentsData ?? []),
      ...(this.allAgents ?? []),
    ];
    const senderAgent = allCandidates.find((agent: any) =>
      this.matchesProposalSender(agent, proposalData),
    );

    if (!senderAgent) {
      return;
    }

    const existing = this.propertyAgentsData.find((agent: any) =>
      this.isSameAgent(agent, senderAgent),
    );

    if (!existing) {
      this.propertyAgentsData.push({
        ...senderAgent,
        isListingAgent: !!senderAgent?.isListingAgent,
        isSellingAgent: false,
        listingCommission: senderAgent?.listingCommission ?? senderAgent?.listingCom ?? 0,
        saleCommission: senderAgent?.saleCommission ?? senderAgent?.saleCom ?? 0,
      });
    }

    this.propertyAgentsData = this.propertyAgentsData.map((agent: any) => ({
      ...agent,
      isSellingAgent: this.isSameAgent(agent, senderAgent),
    }));
  }

  onPaymentChange(_: any) {
    return;
  }

  addPaymentCondition() {
    this.paymentsConditions.push({
      type: 'SIGNAL',
      valueType: 'PERCENTAGE',
      value: '0',
      paymentMoment: '',
      agencyValue: '0',
      order: this.paymentsConditions.length + 1,
    });
  }

  removePaymentCondition(index: number) {
    this.paymentsConditions.splice(index, 1);
  }

  drop(event: any) {
    moveItemInArray(this.paymentsConditions, event.previousIndex, event.currentIndex);
    this.paymentsConditions = this.paymentsConditions.map((payment, index) => ({
      ...payment,
      order: index + 1,
    }));
  }

  /**
* show sweet alert success
* @param position modal content
*/
  showAlertSuccess(msg: string) {
    Swal.fire({
      //position: 'top-end',
      icon: 'success',
      title: msg,
      showConfirmButton: false,
      timer: 1500,
    });
  }

  /**
  * Title sweet alert
  * @param Error Msg modal content
  */
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: this.translateService.instant('t-something-wrong'),
      text: errorMsg,
      icon: 'warning',
      confirmButtonColor: 'rgb(54, 69, 116)',
      confirmButtonText: this.translateService.instant('t-close')
    });
  }

  addFileCostumer() {
    const inputFile = document.getElementById('input-filec');
    inputFile?.click();
  }

  priceFormat(propertyPrice: any) {
    if (propertyPrice) {
      let price = propertyPrice.toString().split('.');
      const spaces = (price: any) =>
        String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, ' ');
      const price1 = spaces(price[0]);
      if (price.length > 1) return price1 + ',' + price[1];

      return price1;
    } return propertyPrice;
  }

  private hasProposalValue(value: any) {
    return value !== null && value !== undefined && value !== '';
  }

  private refreshProposalExtraInfo() {
    const proposalData = this.proposal?.proposal;
    if (!proposalData) {
      this.additionalProposalDetails = [];
      this.proposalProposersList = [];
      return;
    }

    const details = [
      { label: this.translateService.instant('t-proposals.t-details-client'), value: proposalData.clientName },
      { label: this.translateService.instant('t-proposals.t-details-license-ami-imo'), value: proposalData.licenseImo },
      { label: this.translateService.instant('t-proposals.t-details-bank'), value: proposalData.bank },
      { label: this.translateService.instant('t-proposals.t-details-financing'), value: proposalData.financing },
      { label: this.translateService.instant('t-proposals.t-details-source-funds'), value: proposalData.sourceFunds },
      { label: this.translateService.instant('t-proposals.t-details-cpcv-term'), value: proposalData.promiseContractTime },
      { label: this.translateService.instant('t-proposals.t-details-signal-1'), value: this.formatSignalDetail(proposalData.signalBooster, proposalData.signalBoosterPercent) },
      { label: this.translateService.instant('t-proposals.t-details-signal-2'), value: this.formatSignalDetail(proposalData.signalBooster2, proposalData.signalBooster2Percent) },
      { label: this.translateService.instant('t-proposals.t-details-signal-3'), value: this.formatSignalDetail(proposalData.signalBooster3, proposalData.signalBooster3Percent) },
      { label: this.translateService.instant('t-proposals.t-details-signal-4'), value: this.formatSignalDetail(proposalData.signalBooster4, proposalData.signalBooster4Percent) },
      { label: this.translateService.instant('t-proposals.t-details-purpose'), value: this.formatProposalPurpose(proposalData.purpose) },
      { label: this.translateService.instant('t-proposals.t-details-reserve-value'), value: this.formatFinancialDetail(proposalData.reserveValue) },
      { label: this.translateService.instant('t-proposals.t-details-payment-method'), value: this.formatPaymentMethod(proposalData.paymentMethod) },
      { label: this.translateService.instant('t-proposals.t-details-deed-term'), value: proposalData.deedTime },
      { label: this.translateService.instant('t-proposals.t-details-start-date'), value: proposalData.startDate ? this.getDate(proposalData.startDate) : null },
      { label: this.translateService.instant('t-proposals.t-details-security-deposit'), value: this.formatFinancialDetail(proposalData.securityDeposit) },
      { label: this.translateService.instant('t-proposals.t-details-contract-duration'), value: proposalData.contractDuration },
      { label: this.translateService.instant('t-proposals.t-details-contract-renewal'), value: proposalData.renewalDuration },
      { label: this.translateService.instant('t-proposals.t-details-mediation-store'), value: proposalData.mediationStore },
      { label: this.translateService.instant('t-proposals.t-details-responsible'), value: proposalData.responsible },
      { label: this.translateService.instant('t-proposals.t-details-partner-agency'), value: proposalData.partnerEntityName },
    ];

    this.additionalProposalDetails = details.filter((item) => this.hasProposalValue(item.value));
    this.proposalProposersList = Array.isArray(proposalData.proposalProposers) ? proposalData.proposalProposers : [];
  }

  getProposalProposerName(proposer: any) {
    const contactName = [proposer?.contact?.firstName, proposer?.contact?.lastName]
      .filter(Boolean)
      .join(' ')
      .trim();

    return proposer?.name || proposer?.contact?.fullName || contactName || proposer?.company || '-';
  }

  getProposalProposerIdentifier(proposer: any) {
    return proposer?.fiscalIdentification ?? proposer?.companyFiscalIdentification ?? null;
  }

  getProposalProposerTypeLabel(proposer: any) {
    const proposerTypeMap: Record<string, string> = {
      LEGAL: 't-proposals.t-proposer-type-legal',
      EFFECTIVE_BENEFICIARY: 't-proposals.t-proposer-type-effective-beneficiary',
      FIATHER: 't-proposals.t-proposer-type-fiather',
      INDIVIDUAL: 't-proposals.t-proposer-type-individual',
    };
    const translationKey = proposerTypeMap[String(proposer?.type ?? '').toUpperCase()];
    if (!translationKey) return null;
    return this.getSafeLabel(translationKey, null);
  }

  private getSafeLabel(key: string, fallback: string | null = key) {
    const label = this.translateService.instant(key);
    if (!label || label === key || label.includes('?')) {
      return fallback;
    }
    return label;
  }

  private formatProposalPurpose(value: any) {
    const purposeMap: Record<string, string> = {
      PERMANENT: 't-proposals.t-purpose-permanent',
      SECONDARY: 't-proposals.t-purpose-secondary',
      INVESTMENT: 't-proposals.t-purpose-investment',
    };
    const translationKey = purposeMap[String(value ?? '').toUpperCase()];
    if (!translationKey) return value;
    return this.getSafeLabel(translationKey, value);
  }

  private formatPaymentMethod(value: any) {
    const paymentMethodMap: Record<string, string> = {
      CASH: 't-proposals.t-payment-method-cash',
      CHECK_REAL: 't-proposals.t-payment-method-check-real',
      CHECK_OWNER: 't-proposals.t-payment-method-check-owner',
      TRANSFER_REAL: 't-proposals.t-payment-method-transfer-real',
      TRANSFER_OWNER: 't-proposals.t-payment-method-transfer-owner',
    };
    const translationKey = paymentMethodMap[String(value ?? '').toUpperCase()];
    if (!translationKey) return value;
    return this.getSafeLabel(translationKey, value);
  }

  private formatSignalDetail(value: any, isPercent: any) {
    const percent = isPercent === true || `${isPercent}` === 'true';
    const num = Number(value);
    if (
      percent &&
      value !== null &&
      value !== undefined &&
      value !== '' &&
      !Number.isNaN(num) &&
      num !== 0
    ) {
      return `${value}%`;
    }
    return this.formatFinancialDetail(value);
  }

  private formatFinancialDetail(value: any) {
    const numericValue = this.parseNumericValue(value);
    if (numericValue === null) {
      return this.hasProposalValue(value) ? value : null;
    }

    if (numericValue === 0) {
      return null;
    }

    return `${this.priceFormat(numericValue)} €`;
  }

  private parseNumericValue(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    if (typeof value !== 'string') {
      return null;
    }

    let normalized = value.trim().replace(/\s/g, '');
    if (!normalized) {
      return null;
    }

    const hasComma = normalized.includes(',');
    const hasDot = normalized.includes('.');

    if (hasComma && hasDot) {
      if (normalized.lastIndexOf(',') > normalized.lastIndexOf('.')) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = normalized.replace(/,/g, '');
      }
    } else if (hasComma) {
      normalized = normalized.replace(',', '.');
    }

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }

  getDate(date: Date) {
    date = new Date(date);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  getProposalStatusLabel(status: any): string {
    const translateKey = this.getProposalStatusTranslationKey(status);
    return translateKey ?? status?.proposalStatus ?? '';
  }

  private getProposalStatusTranslationKey(status: any): string | null {
    const normalizedStatus = String(
      status?.proposalStatusCode ??
      status?.originalStatus ??
      status?.proposalStatus ??
      ''
    ).trim().toLowerCase();

    if (!normalizedStatus) {
      return null;
    }

    if (normalizedStatus === 'reserved' || normalizedStatus.includes('reserv')) {
      return 't-proposals.t-status-reserved';
    }

    if (
      normalizedStatus === 'sale agreement' ||
      normalizedStatus.replace(/\s+/g, '') === 'saleagreement' ||
      normalizedStatus === 'cpcv'
    ) {
      return this.isRentProposal()
        ? 't-proposals.t-status-lease-agreement'
        : 't-proposals.t-status-cpcv';
    }

    return null;
  }

  isLatestStatusAccepted(proposal: PropertyProposalsModel | null = this.proposal): boolean {
    return this.getNormalizedHistoryStatusCode(this.getLatestHistory(proposal)) === 'accepted';
  }

  isHistoryStatusReserved(history: any): boolean {
    return this.getNormalizedHistoryStatusCode(history) === 'reserved';
  }

  getBadge(icon: any) {
    if (icon) {
      switch (icon) {
        case 'ri-close-circle-line':
          return 'badge-soft-danger'
        case 'ri-check-double-line':
          return 'badge-soft-success'
        case 'ri-trophy-line':
          return 'badge-soft-gold'
        default:
          return 'badge-soft-info'
      }
    }
    return 'badge-soft-info';
  }

  getIconColor(icon: any) {
    if (icon) {
      switch (icon) {
        case 'ri-close-circle-line':
          return 'bg-danger'
        case 'ri-check-double-line':
          return 'bg-success'
        case 'ri-trophy-line':
          return 'bg-gold'
        default:
          return 'bg-light text-success'
      }
    }
    return 'bg-light text-success';
  }

  getData() {
    this.eventService.broadcast('get-proposals-by-view');
  }

  openEdit() {
    this.eventService.broadcast('open-edit-proposal');
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
